module.exports = __webpack_public_path__ + "static/media/S21-1827_$1_Coffee_Banners_Mobile_767x845_ROC_FR.d019a558.jpg";